<div class="back_img">
  <div class="container">
     <div class="row add-p-tb">
        <div class="col-12 d-flex align-items-center bg-white">
           <div class="container my-auto">
              <div class="row">
                 <div class="col-12 error-box">
                    <h1>404</h1>
                    <h3 class="add-c-m"><i class="fa fa-warning"></i> Oops! Page not found!</h3>
                    <p>The page you requested was not found.</p>
                    <div class="btn-group">
                      <button type="button" (click)="goBack()" class="btn btn-danger"><i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back</button>
                      <button type="button" (click)="goHome()" class="btn btn-primary"><i class="fa fa-home" aria-hidden="true"></i> Go Home</button>
                    </div>

                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>
<!-- /Main Wrapper -->
